// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpponentVideoItem__video-container-d27fa2 {
  margin-inline-end: 8px;
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  flex: 0 0 auto;
  cursor: pointer;
}

.OpponentVideoItem__video-container-d27fa2 video {
  object-fit: cover;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/Shared/SpeakerVideo/Opponents/components/OpponentVideoItem/OpponentVideoItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;EACA,YAAA;AACF","sourcesContent":[".video-container {\n  margin-inline-end: 8px;\n  width: 72px;\n  height: 72px;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  flex: 0 0 auto;\n  cursor: pointer;\n}\n\n.video-container video {\n  object-fit: cover;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-container": `OpponentVideoItem__video-container-d27fa2`,
	"videoContainer": `OpponentVideoItem__video-container-d27fa2`
};
module.exports = ___CSS_LOADER_EXPORT___;
